// extracted by mini-css-extract-plugin
module.exports = {"cell-container":"VIP_AverageDepth__cell-container","cellContainer":"VIP_AverageDepth__cell-container","message":"VIP_AverageDepth__message"};